import React from 'react';
import { PropertyLanding } from './pages/PropertyLanding';
export function App() {
  return <PropertyLanding data-id="element-0" />;
}